import React from 'react';
import WebsiteChecks from './sidebar/WebsiteChecks';
import YourWebsiteLink from './sidebar/YourWebsiteLink';
import SidebarContainer from '../../../components/sideBar/SidebarContainer';

const SettingsSidebar = () => {
    return (
        <SidebarContainer>
            <WebsiteChecks />
            <YourWebsiteLink />
        </SidebarContainer>
    );
};

export default SettingsSidebar;
